import { array, literal, object, string } from "superstruct";

import type { PathParamsBase } from "../endpoint/Endpoint.js";
import Endpoint from "../endpoint/Endpoint.js";
import EndpointRouter from "../endpoint/EndpointRouter.js";
import { CandidateSerializedSchema } from "../models/Candidate.js";
import { type Projet } from "../models/Projet.js";
import { type User } from "../models/User.js";

export default function buildCandidateRouter(
    base: EndpointRouter<PathParamsBase, { user: User; projet: Projet }>,
) {
    const router = base.addRouter(new EndpointRouter());

    const endpoints = {
        getCandidatesEndpoint: router.addEndpoint(
            new Endpoint()
                .setMethod("GET")
                .setPath("/candidates", object({}))
                .setResultParser(array(CandidateSerializedSchema)),
        ),
        getCandidateEndpoint: router.addEndpoint(
            new Endpoint()
                .setMethod("GET")
                .setPath("/candidates/:user", object({ user: string() }))
                .setResultParser(CandidateSerializedSchema),
        ),
        updateCandidateEndpoint: router.addEndpoint(
            new Endpoint()
                .setMethod("PUT")
                .setPath("/candidates/:user", object({ user: string() }))
                .setResultParser(literal(null))
                .setBodySchema(CandidateSerializedSchema),
        ),
    };

    return { router, endpoints };
}
